"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importDefault(require("react"));
var main_1 = require("./screens/main");
var react_redux_1 = require("react-redux");
var store_1 = require("./store");
var react_router_dom_1 = require("react-router-dom");
var App = function () {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.redux_store },
        react_1.default.createElement(react_router_dom_1.HashRouter, null,
            react_1.default.createElement(main_1.MainScreen, null))));
};
exports.App = App;
